import { render } from "./sv-show-image.vue?vue&type=template&id=11ab08b7&scoped=true&ts=true"
import script from "./sv-show-image?vue&type=script&lang=ts&external"
export * from "./sv-show-image?vue&type=script&lang=ts&external"

import "./sv-show-image.scss?vue&type=style&index=0&id=11ab08b7&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ab08b7"]])

export default __exports__